export enum CHECKOUT_SOURCE {
  MARKETPLACE_WEB = "web_native",
  MARKETPLACE_WEB_SIGNUP = "web_native_signup",
  BNPL_WEB = "bnpl_web",
}

const SIGNUP_PRODUCT_BY_SOURCE: Record<CHECKOUT_SOURCE, string> = {
  [CHECKOUT_SOURCE.BNPL_WEB]: "BNPL_CHECKOUT",
  [CHECKOUT_SOURCE.MARKETPLACE_WEB]: "MARKETPLACE",
  [CHECKOUT_SOURCE.MARKETPLACE_WEB_SIGNUP]: "MARKETPLACE",
}

export const signupProductForSource = (checkoutSource: CHECKOUT_SOURCE): string => SIGNUP_PRODUCT_BY_SOURCE[checkoutSource]

export enum USER_COHORT {
  NEW = "new",
  RETURNING = "returning",
}
